/* HEADER LOAD */

/* LOAD HEADER ELEMENTS UNTIL DINGO-CUSTOM.CSS IS LOADED */
  document.addEventListener("DOMContentLoaded", function () {
    const dingoCustomCss = document.getElementById("dingo-custom-css");
    if (!dingoCustomCss) {
      console.error("CSS link with id 'dingo-custom-css' not found.");
      return;
    }

    const headerHiddenElements = document.querySelectorAll(".header-hidden");

    const checkCssLoaded = (cssLink, callback) => {
      if (!cssLink) return callback(false);

      const img = document.createElement("img");
      img.onerror = () => callback(true);
      img.src = cssLink.href;

      // Fallback if onerror doesn't work for some browsers
      setTimeout(() => {
        const sheet = Array.from(document.styleSheets).find(
          (sheet) => sheet.href === cssLink.href
        );
        callback(!!sheet);
      }, 3000); // 3 seconds timeout
    };

    checkCssLoaded(dingoCustomCss, (cssLoaded) => {
      if (cssLoaded) {
        headerHiddenElements.forEach((element) => {
          element.classList.add("header-show");
          element.classList.remove("header-hidden");
        });
        //console.log("CSS loaded, header-show class added.");
      } else {
        //console.log("CSS failed to load.");
      }
    });
  });


  /* SHOW THE RIGHT LOGO AT THE TOP MENU */
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.querySelector("body");

    if (body.classList.contains("light-header")) {
      const lightLogo = document.querySelector(".header__heading-logo-main");
      if (lightLogo) {
        lightLogo.classList.remove("hidden");
        //console.log("Light header, hidden class removed from header__heading-logo-main.");
      }
    } else if (body.classList.contains("dark-header")) {
      const darkLogo = document.querySelector(".header__heading-logo-dark");
      if (darkLogo) {
        darkLogo.classList.remove("hidden");
        //console.log("Dark header, hidden class removed from header__heading-logo-dark.");
      }
    }
  });





/* CART DRAWER: Open Cart Drawer form Top Menu item */
  document.addEventListener("DOMContentLoaded", function () {
    const cartIcon = document.querySelector(".header__icon--cart");
    const cartDrawer = document.querySelector(".drawer");

    if (cartIcon && cartDrawer) {
      cartIcon.addEventListener("click", function () {
        cartDrawer.classList.add("active");
        document.body.classList.add("overflow-hidden");
      });
    }
  });



/* MEGAMENU */

/* MEGAMENU - SEARCH BUTTON */
  document.addEventListener("DOMContentLoaded", function () {
    const searchBtn = document.querySelector(".icon-search");

    if (searchBtn) {
      searchBtn.addEventListener("click", function () {
        toggleSearchBtn();
      });
    }

    const toggleSearchBtn = () => {
          
      if (!document.body.classList.contains("search-modal-open")) {
        document.body.classList.add("search-modal-open");
      } else {
        (document.body.classList.contains("search-modal-open")) 
        document.body.classList.remove("search-modal-open");
      }
      
    };
    
  });
 
/* MEGAMENU - LAST CHANCE DROPDOWN MENU */
  document.addEventListener("DOMContentLoaded", function () {
    const lastChanceBtn = document.querySelector(
      "#header-menu-left .header__inline-menu.dropdown-menu"
    );

    if (lastChanceBtn) {
      lastChanceBtn.addEventListener("click", function () {
        toggleLastChanceBtn();
      });
    }

    const toggleLastChanceBtn = () => {
      if (!document.body.classList.contains("last-chance-open")) {
        document.body.classList.add("last-chance-open");
      } else {
        document.body.classList.contains("last-chance-open");
        document.body.classList.remove("last-chance-open");
      }
    };
  });

/* MEGAMENU - CHANGE COLOR OF HEADER */
  document.addEventListener("DOMContentLoaded", function () {
    const megaMenus = document.querySelectorAll(".mega-menu");

    if (megaMenus.length > 0) {
      const toggleMegaMenuClass = () => {
        
        let anyOpen = false;
        
        megaMenus.forEach(megaMenu => {
          if (megaMenu.hasAttribute("open")) {
            anyOpen = true;
          }
        });

        if (anyOpen) {
          if (!document.body.classList.contains("mega-menu-open")) {
            document.body.classList.add("mega-menu-open");
            document.body.classList.remove("dropdown-open");
          }
        } else {
          if (document.body.classList.contains("mega-menu-open")) {
            document.body.classList.remove("mega-menu-open");
          }
        }
      };

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
          ) {
            toggleMegaMenuClass();
          }
        }
      });

      megaMenus.forEach(megaMenu => {
        observer.observe(megaMenu, { attributes: true });
      });

      // Initial check in case the attribute is already present
      toggleMegaMenuClass();
    }
  });


/* SUBMENU DROPDOWN */
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.querySelector("body");
    const dropdownItems = document.querySelectorAll(".dropdown-menu");

    if (dropdownItems.length > 0) {
      dropdownItems.forEach((dropdownItem) => {
        const menuItems = dropdownItem.querySelectorAll(".header__menu-item");

        menuItems.forEach((menuItem) => {
          menuItem.addEventListener("click", function () {
            if (!body.classList.contains("dropdown-open")) {
              body.classList.add("dropdown-open");
            } else {
              body.classList.remove("dropdown-open");
            }
          });
        });
      });
    }
  });

  

/* MOBILE MEGAMENU */
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.querySelector("body");
    const hamburguerMenuIcon = document.querySelector("#hamburguer-menu-icon");

    if (hamburguerMenuIcon) {
      hamburguerMenuIcon.addEventListener("click", function () {
        toggleHamburguerMenu();
      });
    }

    const toggleHamburguerMenu = () => {
      if (listMenu) {
        if (!listMenu.classList.contains("open-menu")) {
          listMenu.classList.add("open-menu");
          body.classList.add("mobile-menu");
        } else {
          listMenu.classList.remove("open-menu");
          body.classList.remove("mobile-menu");
        }
      }
    };

    // Function to update the icon class based on body class
    function updateHamburguerMenuIcon() {
      if (document.body.classList.contains("mobile-menu")) {
        hamburguerMenuIcon.classList.add("icon-close");
        hamburguerMenuIcon.classList.remove("icon-open");
      } else {
        hamburguerMenuIcon.classList.add("icon-open");
        hamburguerMenuIcon.classList.remove("icon-close");
      }
    }

    // Initial check
    updateHamburguerMenuIcon();

    // MutationObserver to listen for changes to the body class
    const observer = new MutationObserver(updateHamburguerMenuIcon);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // When clicking a menu item
    const listMenu = document.querySelector(".list-menu");
    const menuItem = document.querySelectorAll(".header__menu-item");

    if (listMenu) {
      menuItem.forEach((item) => {
        item.addEventListener("click", function () {
          listMenu.classList.add("mega-menu-opened");
          item.classList.add("hide-item");
        });
      });
    }

    // When clicking the close button inside Mega Menu
    const megaMenus = document.querySelectorAll(".mega-menu");

    megaMenus.forEach((menu) => {
      const megaClose = menu.querySelector(".mega-menu-return");

      if (megaClose) {
        megaClose.addEventListener("click", function () {
          menu.removeAttribute("open");
        });
      }
    });

    // Selecting Mega Menu Items
    const megaMenuContents = document.querySelectorAll(".mega-menu__content");

    megaMenuContents.forEach((container) => {
      const megaItems = container.querySelectorAll(".megamenu-col");
      const megaItemsImages = container.querySelectorAll(".megamenu-col-images");

      let collectionIndex = 0;

      megaItems.forEach((item, index) => {
        // Add class to the first item
        if (index === 0) {
          item.classList.add("megamenu-col-first");
        }
        // Add class to the second item if it exists
        if (index === 1) {
          item.classList.add("megamenu-col-second");
        }
      });

      megaItemsImages.forEach((item, index) => {
        if (collectionIndex % 2 === 0) {
          item.classList.add("megamenu-col-odd");
        } else {
          item.classList.add("megamenu-col-even");
        }
        collectionIndex++;
      });
    });
  });

/* MOBILE MEGAMENU: AVOID HORIZONTAL SCROLLING */
  document.addEventListener("DOMContentLoaded", function() {
    const menu = document.querySelector('body.mega-menu-open #header-menu-left .list-menu--inline.open-menu.mega-menu-opened');
    
    if (menu) {
        let startX = 0;
        let startY = 0;

        menu.addEventListener('touchstart', function(event) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        });

        menu.addEventListener('touchmove', function(event) {
            let moveX = event.touches[0].clientX;
            let moveY = event.touches[0].clientY;

            let diffX = moveX - startX;
            let diffY = moveY - startY;

            if (Math.abs(diffX) > Math.abs(diffY)) {
                // Horizontal scroll detected, prevent default action
                event.preventDefault();
            }
        }, { passive: false });
    }
  });




/* PAGES - CREATE TABLE OF CONTENTS */
  document.addEventListener("DOMContentLoaded", function () {
    
    // Find all h3 elements inside the div with class 'main-page-title-wrapper'
    const mainPageWrappers = document.querySelectorAll(".main-page-wrapper");

    mainPageWrappers.forEach((wrapper) => {
      
      const headers = wrapper.querySelectorAll("h6");

      headers.forEach((header) => {
        let nextElement = header.nextElementSibling;
        if (
          nextElement &&
          (nextElement.tagName.toLowerCase() === "ul" ||
            nextElement.tagName.toLowerCase() === "ol")
        ) {
          let tocWrapper = document.createElement("div");
          tocWrapper.className = "table-of-contents";
          header.parentNode.insertBefore(tocWrapper, header);
          tocWrapper.appendChild(header);
          tocWrapper.appendChild(nextElement);
        }
      });
    });

  });



  /* PAGES - AUTO LINK TABLE OF CONTENTS ITEMS */
  document.addEventListener("DOMContentLoaded", function () {
    const tablesOfContents = document.querySelectorAll(".table-of-contents");

    tablesOfContents.forEach((toc) => {
      const listItems = toc.querySelectorAll("li");

      listItems.forEach((listItem) => {
        const link = listItem.querySelector("a");
        const linkText = link.textContent.trim();
        const h2 = findMatchingH2(linkText);
        if (h2) {
          const id = h2.id || generateId(h2.textContent);
          h2.id = id;
          link.href = `#${id}`;
          link.setAttribute("data-mce-href", `#${id}`);
        }
      });
    });

    // Function to find the corresponding h2
    function findMatchingH2(text) {
      const h2s = document.querySelectorAll("h2");
      for (let h2 of h2s) {
        const h2Text = h2.textContent.trim();
        if (h2Text.includes(text)) {
          return h2;
        }
      }
      return null;
    }

    // Function to generate an ID from text
    function generateId(text) {
      return text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    }
  });




/* PAGES - MAKE ALL TABLES RESPONSIVE */
  document.addEventListener("DOMContentLoaded", function () {
    // Select tables inside body.page and inside div with class main-page-wrapper
    const tables = document.querySelectorAll(
      "body.page .main-page-wrapper table"
    );

    tables.forEach((table) => {
      // Create the wrapper div with class "table-responsive"
      const wrapper = document.createElement("div");
      wrapper.classList.add("table-responsive");

      // Insert the wrapper before the table
      table.parentNode.insertBefore(wrapper, table);

      // Move the table inside the wrapper
      wrapper.appendChild(table);
    });
  });




/* PAGES - FIT GUIDE */
  document.addEventListener("DOMContentLoaded", function () {
    // Select all inner tables inside the main table
    const innerTables = document.querySelectorAll(
      "body.page .main-page-wrapper table > tbody > tr > td > .table-responsive"
    );

    // Check if there are at least 4 inner tables
    if (innerTables.length >= 4) {
      innerTables[0].classList.add("table-sizing-charts");
      innerTables[1].classList.add("table-children-size");
      innerTables[2].classList.add("table-women-size");
      innerTables[3].classList.add("table-men-size");
    }
  });




/* FIND A RETAILER */
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const searchForm = document.querySelector(".stockist-search-form");
            const sidePanel = document.querySelector(".stockist-side-panel");

            if (searchForm && sidePanel) {
              // Prepend the search form inside the side panel
              sidePanel.insertBefore(searchForm, sidePanel.firstChild);
              observer.disconnect(); // Stop observing once the elements are found and moved
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

(function waitForStockist() {
  const input = document.querySelector('.stockist-query-entry');

  if (!input) {
    return setTimeout(waitForStockist, 300);
  }

  if (document.querySelector('label[for="' + input.id + '"]')) return;

  const label = document.createElement('label');
  label.setAttribute('for', input.id);
  label.textContent = 'Enter postcode or address';
  label.classList.add('stockist-accessible-label');

  input.parentNode.insertBefore(label, input);

  console.log('Label added!');
})();

(function waitForStockist() {
  const input = document.querySelector('.go3268166022');
  if (!input) return setTimeout(waitForStockist, 300);

  // Ensure input has an ID
  if (!input.id) {
    input.id = 'stockist-email';
  }

  let label = input.parentNode.querySelector('label');

  if (!label) {
    label = document.createElement('label');
    label.setAttribute('for', input.id);
    label.className = 'kl-private-model stockist-label';
    input.parentNode.insertBefore(label, input);
  }

  // FORCE visibility (Klaviyo hides labels by default)
  label.style.display = 'block';

  label.style.setProperty('position', 'static', 'important');
  label.style.setProperty('clip', 'auto', 'important');
  label.style.setProperty('clip-path', 'none', 'important');
  label.style.setProperty('width', 'auto', 'important');
  label.style.setProperty('height', 'auto', 'important');
  label.style.setProperty('overflow', 'visible', 'important');
  label.style.setProperty('white-space', 'normal', 'important');
  label.style.setProperty('z-index', '9999', 'important');
  label.style.setProperty('margin-bottom', '4px', 'important');


  // Set label with asterisk
  label.innerHTML = `Enter your email <span style="color:red">*</span>`;

  // Accessibility
  input.required = true;
  input.setAttribute('aria-required', 'true');

  // Required note (once)
  if (!input.parentNode.querySelector('.required-note')) {
    const note = document.createElement('div');
    note.className = 'required-note';
    note.style.fontSize = '12px';
    note.style.marginTop = '4px';
    note.style.color = '#555';
    note.textContent = 'Fields marked with asterisk (*) are required';
    input.parentNode.appendChild(note);
  }

})();

/* ON VIEW SECTION */
  document.addEventListener("DOMContentLoaded", function () {
    // Define the classes to check for on the body tag
    const validClasses = [
      "page",
      "home",
      "collection",
      "blog",
      "partner",
      "about",
      "influencer",
    ];

    // Check if the body has any of the valid classes
    if (!validClasses.some((cls) => document.body.classList.contains(cls))) {
      return; // Exit the function if none of the classes are present
    }

    // Continue with the rest of the script if the correct body class is present
    const sections = document.querySelectorAll(".dingo-section");
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "0px",
      threshold: 0.5, // 50% of the element should be visible
    };

    let currentActiveSection = null;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Remove the class from the current active section
          if (currentActiveSection) {
            currentActiveSection.classList.remove("dingo-on-view");
          }
          // Add the class to the new active section
          entry.target.classList.add("dingo-on-view");
          currentActiveSection = entry.target;
        } else if (entry.target.classList.contains("dingo-on-view")) {
          // Remove the class if the section is not intersecting
          entry.target.classList.remove("dingo-on-view");
          currentActiveSection = null;
        }
      });
    }, options);

    sections.forEach((section) => {
      observer.observe(section);
    });

    // Function to scale the image as you scroll
    const scaleImagesOnScroll = () => {
      sections.forEach((section) => {
        const images = section.querySelectorAll(
          ":not(.block-inner-image) > img"
        );

        if (images) {
          images.forEach((image) => {
            const rect = section.getBoundingClientRect();
            const scrollPercent =
              (window.innerHeight - rect.top) /
              (window.innerHeight + rect.height);
            let scale;

            if (image.classList.contains("dingo-hero-img")) {
              scale = 0.8 + scrollPercent * 0.5;
            } else {
              scale = 1.2 - scrollPercent * 0.2;
            }

            // Cap the scale value at 1.6
            if (scale > 1.6) {
              scale = 1.6;
            }

            image.style.transform = `scale(${scale})`;
          });
        }
      });
    };

    // Add a scroll event listener to scale images
    window.addEventListener("scroll", scaleImagesOnScroll);

    // Initial call to scale images
    scaleImagesOnScroll();
  });





/* SINGLE PAGE - REVIEWS */
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Check for the yotpo widget within the added node
            const yotpoElement = node.id.includes("yotpo-app")
              ? node
              : node.querySelector("#yotpo-app");
            if (yotpoElement) {
              const shopifySection = yotpoElement.closest(".shopify-section");
              if (
                shopifySection &&
                !shopifySection.classList.contains("shopify-section-yotpo")
              ) {
                shopifySection.classList.add("shopify-section-yotpo");
              }
            }

            // Check specifically within the context of the added node
            if (
              node.matches(".yotpo-layout-header-wrapper") ||
              node.querySelector(".yotpo-layout-header-wrapper")
            ) {
              const yotpoWidget = node.matches(".yotpo-layout-header-wrapper")
                ? node
                : node.querySelector(".yotpo-layout-header-wrapper");
              if (!yotpoWidget.querySelector(".yotpo-bottom-title-new")) {
                const newDiv = document.createElement("div");
                newDiv.className = "yotpo-bottom-title";
                const newHeading = document.createElement("h3");
                newHeading.textContent = "What Our Wearers Are Saying";
                newDiv.appendChild(newHeading);
                yotpoWidget.prepend(newDiv);
                console.log("Added title to yotpo widget.");
              }
            }
          }
        });
      });
    });

    const config = {
      childList: true,
      subtree: true,
    };

    observer.observe(document.body, config);
    //console.log("Observer has been set up to monitor changes in the DOM.");
  });




/* PARTNERSHIP */
  document.addEventListener("DOMContentLoaded", function () {
    const autoplayButton = document.querySelector(
      ".slideshow__autoplay.slider-button"
    );
    const slideshow = document.querySelector(".slideshow");
    const collabSliderComponent = document.querySelector(
      ".collab-slider-component"
    );

    if (!autoplayButton || !slideshow || !collabSliderComponent) return;

    // Simulate a click on the autoplay button to fake the initial click
    autoplayButton.click();

    // Adding click event to autoplay button to toggle autoplay
    autoplayButton.addEventListener("click", function () {
      // Toggle the paused class on the autoplay button
      autoplayButton.classList.toggle("slideshow__autoplay--paused");

      // Change data-autoplay attribute on the slideshow element
      if (slideshow.getAttribute("data-autoplay") === "false") {
        slideshow.setAttribute("data-autoplay", "true");
        playSlideshow();
      } else {
        slideshow.setAttribute("data-autoplay", "false");
        pauseSlideshow();
      }
    });

    function playSlideshow() {
      // Logic to start the slideshow autoplay
      if (slideshow.play) {
        slideshow.play();
      }
    }

    function pauseSlideshow() {
      // Logic to stop the slideshow autoplay
      if (slideshow.pause) {
        slideshow.pause();
      }
    }

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (collabSliderComponent.classList.contains("dingo-on-view")) {
            // Simulate a click on the autoplay button to start the slideshow
            autoplayButton.click();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(collabSliderComponent, { attributes: true });
  });


// Write a review btn foucs
let lastClickedReviewBtn = null;
let savedScrollY = 0;

function lockScroll() {
  savedScrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.width = "100%";
}

function unlockScroll() {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  window.scrollTo(0, savedScrollY);
}

document.addEventListener("click", (e) => {
  const reviewBtn = e.target.closest(".yotpo-sr-bottom-line-new-review");
  const closeBtn = e.target.closest(".yotpo-icon-button__container");

  if (reviewBtn) {
    lastClickedReviewBtn = reviewBtn;
    lockScroll();
  }

  if (closeBtn && lastClickedReviewBtn) {
    const btn = lastClickedReviewBtn;

    requestAnimationFrame(() => {
      setTimeout(() => {
        unlockScroll();
        btn.focus();
        lastClickedReviewBtn = null;
      }, 80);
    });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const searchRoot = document.querySelector('.template-search, predictive-search, main-search');

  if (!searchRoot) return;

  const selector = `
    button:not([disabled]),
    [role="button"],
    a[href],
    input,
    summary,
    select,
    textarea
  `;

  function updateElement(el) {
    const style = window.getComputedStyle(el);

    const isHidden =
      el.hidden ||
      style.display === "none" ||
      style.visibility === "hidden" ||
      parseFloat(style.opacity) === 0 ||
      style.pointerEvents === "none" ||
      (el.offsetWidth === 0 && el.offsetHeight === 0);

    if (isHidden) {
      el.setAttribute("tabindex", "-1");
      el.setAttribute("aria-hidden", "true");
    } else {
      if (el.getAttribute("tabindex") === "-1") el.removeAttribute("tabindex");
      if (el.getAttribute("aria-hidden") === "true") el.removeAttribute("aria-hidden");
    }
  }

  function scan() {
    searchRoot.querySelectorAll(selector).forEach(updateElement);
  }

  scan();

  const observer = new MutationObserver(scan);

  observer.observe(searchRoot, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["style", "class", "hidden"]
  });
});
